import { render, staticRenderFns } from "./StartConfirm.vue?vue&type=template&id=bf16f20c&scoped=true&"
import script from "./StartConfirm.vue?vue&type=script&lang=js&"
export * from "./StartConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf16f20c",
  null
  
)

export default component.exports